import { render } from "./moduleSearch.vue?vue&type=template&id=834b2e92"
import script from "./moduleSearch.vue?vue&type=script&lang=js"
export * from "./moduleSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__